<template>
  <div>
    <wc-page-title title='SUBD Revenue Report'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12' md='8'>
          <wc-data-box
            title='Setup'
          >
            <v-card-text>
              <v-row>
                <v-col>
                  <v-select
                    :items='subd_options'
                    label='Startups or Blowdowns?'
                    v-model='subd'
                  ></v-select>
                </v-col>
                <v-col>
                  <wc-datepicker
                    label='From date'
                    v-model='fromDate'
                    removeClearOption
                    defaultToday
                  />
                </v-col>
                <v-col>
                  <wc-datepicker
                    label='To date'
                    v-model='toDate'
                    removeClearOption
                    defaultToday
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col class='text-right py-0'>
                  <v-btn depressed class='primary' @click='generateReport' :loading='loadingItems'>Generate</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </wc-data-box>
        </v-col>
        <v-col cols='12' md='4' v-if='results.length'>
          <wc-data-box
            title='Summary Results'
          >
            <wc-two-column-table :items='items'></wc-two-column-table>
          </wc-data-box>
        </v-col>
      </v-row>
      <v-row v-if='generatedReport'>
        <v-col cols='12' md='12'>
          <wc-data-box
            title='Details'
            showSearch
            v-model='search'
          >
            <v-data-table
              dense
              :items='results'
              :headers='headers'
              :search='search'
              :items-per-page='-1'
              @click:row='openWO'
              hide-default-footer
            >
              <template v-slot:item.install_date='{ item }'>
                {{ $options.filters.shortDate(item.install_date) }}
              </template>
              <template v-slot:item.date_created='{ item }'>
                {{ $options.filters.shortDate(item.date_created) }}
              </template>
              <template v-slot:item.date_completed='{ item }'>
                {{ $options.filters.shortDate(item.date_completed) }}
              </template>
              <template v-slot:item.cost='{ item }'>
                {{ $options.filters.dec(item.cost) }}
              </template>
              <template v-slot:no-data>
                No results for selected date range.
              </template>
            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import wosAPI from '@/modules/wos/api/index'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'revenue-report',
  data: () => ({
    subd: 'su',
    fromDate: moment().format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),
    results: [],
    loadingItems: false,
    generatedReport: false,
    search: '',
    items: [],
    subd_options: [
      { text: 'Startups', value: 'su' },
      { text: 'Blowdowns', value: 'bd' },
    ],
    headers: [
      { text: 'Project', value: 'project_name' },
      { text: 'Site Address', value: 'project_address' },
      { text: 'Install date', value: 'install_date' },
      { text: 'WO', value: 'wo_display' },
      { text: 'Date Created', value: 'date_created' },
      { text: 'Date Completed', value: 'date_completed' },
      { text: 'SU/BD Cost', value: 'cost', align: 'end' }
    ]
  }),
  methods: {
    async generateReport () {
      this.loadingItems = true
      this.search = ''
      let tmp = await wosAPI.getSUBDRevenueReportWOs(this.subd, this.fromDate, this.toDate)
      this.results = _.orderBy(tmp.wos, 'project_name')
      this.items = [{
        text: 'Total Cost',
        value: this.$options.filters.decMoney(tmp.total)
      }]
      this.loadingItems = false
      this.generatedReport = true
    },
    openWO (line) {
      const link = document.createElement('a')
      const invURL = this.$router.resolve({ name: 'WOOverview', params: { id: line.wo_id } })
      link.target = '_blank'
      link.href = invURL.href
      link.click()
    },
  }
}
</script>
